<template>
      <div class="container">
        <!-- 面包屑 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>机构设置</el-breadcrumb-item>
        </el-breadcrumb>

        <div class="between">
          <div class="left_con">
            <el-input size="mini"
                      style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"
                      placeholder="输入关键字进行过滤"
                      v-model="filterText">
            </el-input>
            <el-tree
              :data="orgList"
              :props="treeProps"
              @node-click="handleNodeClick"
              :highlight-current="true"
              node-key="id"
              :filter-node-method="filterNode"
              ref="tree"
            >
            </el-tree>
          </div>
          <div class="table_container" style="border: 0 solid rgb(222,222,222);margin: 10px 0">
            <el-button size="mini" plain :disabled="disabled" @click="showAddDialogVisible(null,1)"
                       v-if="authorities.includes('system.org.new')">添加部门</el-button>
            <el-table height="550px" :data="shopList" fit border stripe="stripe"
                      :header-cell-style="{background:'#eff3f8', color:'#333'}"
                      :row-style="{height: '0'}" >
              <el-table-column
                align="center"
                label="操作" width="100">
                <template slot-scope="scope">
                  <el-link type="primary" v-if="authorities.includes('system.org.update')" icon="el-icon-edit"
                           @click="showAddDialogVisible(scope.row,2)"></el-link>
                  <el-link type="danger" icon="el-icon-delete" style="padding-left: 10px"
                           v-if="authorities.includes('system.org.delete')" @click="deleteShopBox(scope.row)"></el-link>
                  <el-link type="danger" icon="iconfont icon-close" style="padding-left: 10px"
                           @click="closeShop(scope.row)"></el-link>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="orgName"
                label="门店" width="200">
              </el-table-column>
              <el-table-column
                align="center"
                prop="address"
                label="地址" width="250">
              </el-table-column>
              <el-table-column
                align="center"
                prop="phone"
                label="电话" width="150">
              </el-table-column>
              <el-table-column
                align="center"
                prop="state"
                :formatter="shopStateFormatter"
                label="状态" width="150">
              </el-table-column>
              <el-table-column
                align="center"
                prop="moLingRate"
                label="抹零比例" width="100">
              </el-table-column>
              <el-table-column
                align="center"
                prop="bronzeDiscount"
                label="大众会员折扣" width="100">
              </el-table-column>
              <el-table-column
                align="center"
                prop="goldDiscount"
                label="黄金会员折扣" width="100">
              </el-table-column>
              <el-table-column
                align="center"
                prop="platinumDiscount"
                label="铂金会员折扣" width="100">
              </el-table-column>
              <el-table-column
                align="center"
                prop="diamondDiscount"
                label="钻石会员折扣" width="100">
              </el-table-column>
              <el-table-column
                align="center"
                prop="purchaseLevel"
                :formatter="orgPurchaseLevelFormatter"
                label="采购等级" width="150">
              </el-table-column>
            </el-table>
            <div style="margin-top: 3px;">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageTotal">
              </el-pagination>
            </div>
          </div>
        </div>

        <!-- 添加部门 -->
        <el-dialog
          :title="title"
          :visible.sync="addDialogVisible"
          width="60%"
          style="position: absolute"
          :close-on-click-modal="false"
        >
          <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
          <el-card>
            <div style="display: flex;justify-content: space-around;">
              <div>
                机构名称：
                <el-input v-model="org.orgName" placeholder="请输入内容" size="mini" style="width: 250px"></el-input>
              </div>
              <div>
                机构地址：
                <el-input v-model="org.address" placeholder="请输入内容" size="mini" style="width: 250px"></el-input>
              </div>
            </div>
            <div style="display: flex;justify-content: space-around;margin-top: 10px">
              <div>
                联系电话：
                <el-input v-model="org.phone" placeholder="请输入内容" size="mini" style="width: 250px"
                          onkeyup="value=value.replace(/[^\d-]/g,'')"></el-input>
              </div>
              <div>
                抹零比例：
                <el-input v-model="org.moLingRate" placeholder="请输入整数,最大不能超过15" size="mini" style="width: 250px"
                          onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
              </div>
            </div>
            <div style="display: flex;justify-content: space-around;margin-top: 10px;">
              <div >
                采购价格等级：
                <el-radio-group v-model="org.purchaseLevel" @change="orgPurchaseLevelHandle">
                  <el-radio  :label="1">1级价</el-radio>
                  <el-radio  :label="2">1.5级价</el-radio>
                  <el-radio  :label="3">2级价</el-radio>
                </el-radio-group>
              </div>
              <div>
                机构级别：
                <el-radio-group v-model="org.level" @change="orgLevelHandle" style="width: 250px">
                  <el-radio  :label="2">分公司</el-radio>
                  <el-radio  :label="3">门店</el-radio>
                </el-radio-group>
              </div>
            </div>
          </el-card>
          <div style="margin-top: 10px;">
            <span >会员折扣:</span>
          </div>
          <el-card >
            <div style="display: flex; justify-content: flex-start;align-items: center">
              <div style="width: 25%">
                <span style="width: 20%">钻石会员：</span>
                <el-input v-model="org.diamondDiscount" placeholder="请输入折扣" size="mini" style="width: 70%"
                          onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
              </div>
              <div style="width: 25%">
                <span style="width: 20%">铂金会员：</span>
                <el-input v-model="org.platinumDiscount" placeholder="请输入折扣" size="mini" style="width: 70%"
                          onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
              </div>
              <div style="width: 25%">
                <span style="width: 20%">黄金会员：</span>
                <el-input v-model="org.goldDiscount" placeholder="请输入折扣" size="mini" style="width: 70%"
                          onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
              </div>
              <div style="width: 25%">
                <span style="width: 20%">大众会员：</span>
                <el-input v-model="org.bronzeDiscount" placeholder="请输入折扣" size="mini" style="width: 70%"
                          onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
              </div>
            </div>
          </el-card>
          <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="cancel">取 消</el-button>
            <el-button size="mini" @click="addOrgMethod">确 定</el-button>
          </span>
        </el-dialog>
      </div>
</template>

<script>
export default {
  data(){
    return{
      authorities:'',
      title:'',
      orgList: [],
      shopList:[],
      showInput: true,
      treeProps: {
        label: 'orgName',
        children: 'children'
      },
      org:{
        parentId: '',
        orgName: '',
        level: '',
        address: '',
        phone: '',
        orderNo: '',
        creator: '',
        id:'',
        modifier: '',
        purchaseLevel:'',
        bronzeDiscount:'',
        goldDiscount:'',
        platinumDiscount:'',
        diamondDiscount:'',
        // starDiscount:'',
        // #kingDiscount:'',
        moLingRate:''
      },
      selectOrg:'',
      orgId: '',
      filterText: '',
      disabled: false,
      operatorType: '',
      addDialogVisible: false,
      stateTypeList:[
        {valida:1,name:"无效"},
        {valida:2,name:"正常"}
      ],
      orgPurchaseLevelText:[
        {purchaseLevel:1,name:"1级价"},
        {purchaseLevel:2,name:"1.5级价"},
        {purchaseLevel:3,name:"2级价"},
      ],
      shopStateText:[
        {state:1,name:'营业中'},
        {state:2,name:'闭店'}
      ],
      currentPage: 1,
      pageSize:20,
      pageTotal:0,
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods:{
    orgPurchaseLevelFormatter(row){
      let value = "";
      for (let i = 0; i < this.orgPurchaseLevelText.length; i++){
        let item = this.orgPurchaseLevelText[i];
        if (row.purchaseLevel === item.purchaseLevel) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    async handleNodeClick(data) {
      if (data.level === 3){
        this.disabled = true;
      } else {
        this.disabled = false;
      }
      this.selectOrg = data;
      await this.loadShopList();
    },
    async loadShopList(){
      const {data:res} = await this.$http.get(`/org/shopList/${this.selectOrg.id}/pageNum/${this.currentPage}/pageSize/${this.pageSize}`);
      this.shopList = res.data.list;
      this.pageTotal = res.data.total;
    },
    orgLevelHandle(val){
      this.level = val;
    },
    orgPurchaseLevelHandle(val){
      this.org.purchaseLevel = val;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.orgName.indexOf(value) !== -1;
    },
    async loadOrg(){
      const {data:res} = await this.$http.get(`/orgs/areaList/orgId/${this.orgId}`);
      this.orgList = [res.data];
    },
    async showAddDialogVisible(row, type){
      this.operatorType = type;
      if (type === 1){
        this.title = '添加部门';
        this.org.orgName = '';
        this.org.address='';
        this.org.purchaseLeve='';
        this.org.level = '';
        this.org.bronzeDiscount='';
        this.org.diamondDiscount='';
        this.org.platinumDiscount='';
        this.org.goldDiscount='';
      }
      if (type === 2){
        this.title = '修改部门';
        this.org = row;
      }
      this.addDialogVisible = true;
    },
    async addOrgMethod(){
      //1.添加部门
      if (this.operatorType === 1){
        if (this.selectOrg.level === 1){
          this.org.level = 2;
        }
        if (this.selectOrg.level === 2){
          this.org.level = 3;
        }
        this.org.parentId = this.selectOrg.id;
        this.org.creator = this.userId;
        const {data:res} = await this.$http.post(`org/add`,this.org);
        if (res.code !== 200){
          return this.$message.error(res.msg);
        }
        this.$message.success(res.msg);
        if (this.selectOrg.level === 1){
          this.org.level = 2;
          await this.loadOrg();
        }
        if (this.selectOrg.level === 2){
          this.org.level = 3;
          await this.loadShopList();
        }

      }
      //2.表示更新部门
      if (this.operatorType === 2){
        this.org.modifier = this.userId;
        const {data:res} = await this.$http.put(`org/update`, this.org);
        if (res.code !== 200){
          return this.$message.error(res.msg);
        }
        this.$message.success(res.msg);
      }

      await this.loadOrg();
      this.addDialogVisible = false;
    },
    cancel(){
      this.addDialogVisible = false;
    },
    deleteOrgBox(){
      this.$confirm('此操作将永久删除该机构, 是否继续?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.deleteOrg();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    async deleteOrg(){
      const {data:res} = await this.$http.delete(`org/orgId/${this.selectOrg.id}`);
      if (res.code === 200){
        this.$message.success("操作成功！");
      }
      await this.loadOrg();
    },
    deleteShopBox(row){
      this.$confirm('此操作将永久删除该机构, 是否继续?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.deleteShop(row);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    async closeShop(row){
      const {data:res} = await this.$http.get('update/shop/state', {params:{orgId: row.id}});
      if (res.code === 200){
        this.$message.success("操作成功！");
      }
      await this.loadShopList();
    },
    async deleteShop(row){
      const {data:res} = await this.$http.delete(`org/orgId/${row.id}`);
      if (res.code === 200){
        this.$message.success("操作成功！");
      }
      await this.loadShopList();
    },
    stateFormatter(row, column){
      let value = "";
      for (let i = 0; i < this.stateTypeList.length; i++){
        let item = this.stateTypeList[i];
        if (row.valida === item.valida) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    shopStateFormatter(row, column){
      let value = "";
      for (let i = 0; i < this.shopStateText.length; i++){
        let item = this.shopStateText[i];
        if (row.state === item.state) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    //拖拽保存方法
    async handleDrop(draggingNode, dropNode, dropType, ev){
      const paramData = [];
      // 当拖拽类型不为inner,说明只是同级或者跨级排序，只需要寻找目标节点的父ID，获取其对象以及所有的子节点，并为子节点设置当前对象的ID为父ID即可
      // 当拖拽类型为inner，说明拖拽节点成为了目标节点的子节点，只需要获取目标节点对象即可
      const data = dropType !== "inner" ? dropNode.parent.data : dropNode.data;
      const nodeData = dropNode.level === 1 && dropType !== "inner" ? data : data.children;
      // 设置父ID,当level为1说明在第一级，pid为空
      nodeData.forEach(element => {
        element.pid = dropNode.level === 1 ? "" : data.id;
      });
      nodeData.forEach((element, i) => {
        const dept = {
          deptId: element.id,
          parentDeptId: element.pid,
          order: i
        };
        paramData.push(dept);
      });

      // this.loading = true;
      // 得到这次操作需要变更的数据范围，请求后台批量处理即可...
      const {data:res} =  await this.$http.put(`org/orgListOrder`, paramData);
      if (res.code === 200){
        this.$message.success("顺序调整成功")
        // this.orgList = [res.data];
      }
    },
    allowDrop(moveNode, inNode, type) {
      if(moveNode.level=== 1 && inNode.level===1){
        // 四种情况
        if(moveNode.nextSibling === undefined){
          return type === 'prev';
        } else if(inNode.nextSibling === undefined){
          return type === 'next';
        } else if(moveNode.nextSibling.id !== inNode.id){
          return type === 'prev';
        } else {
          return type === 'next';
        }
      }
      //是否为同级下的子节点
      if(moveNode.level === 2 && inNode.level === 2 && moveNode.parent.id === inNode.parent.id){
        // 四种情况
        if(moveNode.nextSibling === undefined){
             return type === 'prev';
        } else if(inNode.nextSibling === undefined){
             return type === 'next';
        } else if(moveNode.nextSibling.id !== inNode.id){
             return type === 'prev';
        }else{
             return type === 'next';
        }
      }
      //是否为同级下的子节点
      if(moveNode.level === 3 && inNode.level === 3 && moveNode.parent.id === inNode.parent.id){
        // 四种情况
        if(moveNode.nextSibling === undefined){
          return type === 'prev';
        } else if(inNode.nextSibling === undefined){
          return type === 'next';
        } else if(moveNode.nextSibling.id !== inNode.id){
          return type === 'prev';
        }else{
          return type === 'next';
        }
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadShopList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadShopList();
    },
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.loadOrg();
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 90vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}
.left_con{
  height: 100%;
  overflow-y: auto;
  flex: 1;
  margin: 10px 0;
  /*border: 1px solid;*/
}
.table_container{
  width: 80%;
  flex: 4;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.outside_con{
  height: 250px;
}
.dialog-footer{
  display: flex;
  margin-top: 50px;
  //margin: 10px 10px;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Orgs.vue